import { render, staticRenderFns } from "./AuthIlustracao.vue?vue&type=template&id=adcb2c7e&"
import script from "./AuthIlustracao.vue?vue&type=script&lang=js&"
export * from "./AuthIlustracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports